// extracted by mini-css-extract-plugin
export default {"innerWrapper":"lt-z","tooltipWrapper":"mt-z","icon":"nt-z","tooltip":"ot-z","content":"pt-z"};